export default __webpack_public_path__ + "static/media/process_03.901ceaad.png";